<template>
  <div class="map_box">
        <div id="tmap"></div>
      <el-button @click="showMarker" class="btn" size="small">显示多个标记</el-button>
  </div>
</template>

<script>
export default {
  name: 'TencentMap',
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      TMap: window.TMap,
      center: {},
      markerArr: [], // 标注点
      map: '',
      urls: {
        map1: require('@/assets/tmap/map1.png'),
        map2: require('@/assets/tmap/map2.png')
      },
      radius: 250, // 半径范围
      checkInCenter: {}, // 当前打卡点
      currentInCenter: {}, // 我打卡点
      mapInfo: { }
    }
  },
  created () {
    this.mapInfo = this.obj
  },
  mounted () {
    this.$nextTick(() => {
      // 处理当前需要用到的坐标
      this.checkInCenter = {
        lat: this.mapInfo.checkinTencentLat,
        lng: this.mapInfo.checkinTencentLng
      }
      this.currentInCenter = {
        lat: this.mapInfo.orginLatitude,
        lng: this.mapInfo.orginLongitude
      }
      this.initMap()
    })
  },
  destroyed () {
    this.tMap.destroy()
  },

  methods: {
    initMap () {
      let _self = this
      let TMap = _self.TMap
      // 定义地图中心点坐标
      _self.loading = true
      var center = new TMap.LatLng(this.currentInCenter.lat, this.currentInCenter.lng)
      _self.center = center
      this.TXMap = TMap
      this.tMap = new TMap.Map(document.getElementById('tmap'), {
        center: center, // 设置地图中心点坐标
        zoom: 17, // 设置地图缩放级别
        viewMode: '2D', // 设置地图的效果
        rotation: 0, // 设置地图旋转角度
        pitch: 0 // 2d下无效设置俯仰角度（0~45）
      })
      var map = this.tMap
      map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM) // 移除缩放控件
      map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE) // 移除距离控件
      map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION) // 移除旋转控件
      this.handleMarker()

      // 监听地图瓦片加载完成事件
      this.tMap.on('tilesloaded', function () {
        _self.loading = false
      })
    },
    handleMarker () {
      var _self = this
      var TMap = this.TMap
      var map = this.tMap

      this.markerArr = [

        {
          'id': 'marker1',
          'styleId': 'marker1',
          'position': new TMap.LatLng(_self.currentInCenter.lat, _self.currentInCenter.lng),
          'properties': {
            'title': '自身打卡位置'
          }
        },
        {
          'id': 'marker2',
          'styleId': 'marker2',
          'position': new TMap.LatLng(_self.checkInCenter.lat, _self.checkInCenter.lng),
          'properties': {
            'title': '考勤点位置'
          }
        }
      ]
      // 创建显示范围
      var circle = new TMap.MultiCircle({
        id: 'circle',
        map,
        styles: { // 设置圆形样式
          'circle': new TMap.CircleStyle({
            'color': 'rgba(41,91,255,0.16)',
            'showBorder': true,
            'borderColor': 'rgba(41,91,255,1)',
            'borderWidth': 2
          })
        },
        geometries: [{
          styleId: 'circle',
          center: new TMap.LatLng(_self.checkInCenter.lat, _self.checkInCenter.lng), // 设置圆的中心
          radius: _self.radius // 设置圆的半径
        }]
      })
      var marker = new TMap.MultiMarker({
        id: 'marker-layer1',
        map: _self.tMap,
        styles: {
          // mark样式
          'marker1': new TMap.MarkerStyle({
            'width': 25,
            'height': 35,
            'anchor': { x: 12, y: 32 },
            'src': this.urls.map1
          }),
          'marker2': new TMap.MarkerStyle({
            'width': 25,
            'height': 35,
            'anchor': { x: 12, y: 32 },
            'src': this.urls.map2
          })
        },

        geometries: this.markerArr
      })
    },
    showMarker () {
      var TMap = this.TMap
      var map = this.tMap
      var bounds = new TMap.LatLngBounds()
      // 判断标注点是否在范围内
      this.markerArr.forEach(function (item) {
        // 若坐标点不在范围内，扩大bounds范围
        if (bounds.isEmpty() || !bounds.contains(item.position)) {
          bounds.extend(item.position)
        }
      })
      // 设置地图可视范围
      map.fitBounds(bounds, {
        padding: 100 // 自适应边距
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.map_box{
  position: relative;
}
.tmap{
    width: 100%;
    height: 100%;
    min-height: 500px;
}
.btn{
        position: absolute;
        left: 10px;
        top: 10px;
        z-index: 9999;
    }
</style>
